<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewBranch()">
            New Branch
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-card>
          <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            v-bind:search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span v-on="on">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item="row"
              ><tr>
                <td>{{ row.item.branch }}</td>
                <td class="text-xs-left">{{ row.item.brnDesc }}</td>
                <td class="text-xs-left">{{ row.item.brnCty }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery" review @review="doBranchReview" remove @remove="doPromptRemove"></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Please note that all related DRI and Fee records will also be deleted. Please confirm deletion of this records.
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Description', align: 'left', value: 'brnDesc' },
        { text: 'Default Country', align: 'left', value: 'brnCty' },
        TableConst.tableActionHeader
      ],
      totalDri: 0,
      selectedBranch: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    branchMenu() {
      return this.$store.state.branchParam.menu
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.branchMenu.getBranchList
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((Branch) => {
              const convertBranch = {
                branch: Branch.branch,
                brnDesc: Branch.brnDesc,
                brnCty: Branch.defCty
              }
              this.items.push(convertBranch)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doBranchReview(Branch) {
      this.$router.push({ name: 'branchReview', params: { brn: Branch.item.branch, tranMode: 'Review' } })
    },
    doNewBranch() {
      this.$router.push({ name: 'branchReview', params: { brn: 'new', tranMode: 'New' } })
    },
    doRemove() {
      const apiURI = this.$store.state.branchParam.menu.deleteBranch
      if (apiURI) {
        const expand = this.selectedBranch
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.fetchData()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doClearFilters() {
      this.search = null
    },
    async doPromptRemove(data) {
      this.resetMessages()
      this.selectedBranch = data.item
      this.promptRemove = true
    },
    doQuery(Branch) {
      this.$router.push({ name: 'branchReview', params: { brn: Branch.item.branch, tranMode: 'Query' } })
    }
  },
  mounted() {
    this.fetchData()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
